import { generateAccessName, AccessKey } from "../../../../../access";

const ACCESS_SECTION: AccessKey[] = [
	AccessKey.SETTINGS,
	AccessKey.SETTINGS_RECEIPT_PROVIDERS,
];

enum TabKeys {
	PROVIDER = "provider",
}

type TabAccessNamesType = {
	[key in TabKeys]: string;
};

const generateAccessSection = (key: AccessKey): AccessKey[] => [
	...ACCESS_SECTION,
	key,
];

const ARR_ACCESS_PART_KEY: Record<TabKeys, AccessKey[]> = {
	[TabKeys.PROVIDER]: generateAccessSection(AccessKey.MAIN),
};

const TabAccessNames: TabAccessNamesType = Object.fromEntries(
	Object.entries(ARR_ACCESS_PART_KEY).map(([key, section]) => [
		key,
		generateAccessName(...section),
	]),
) as TabAccessNamesType;

const mainPath = `settings.receiptProviders`;

export { TabKeys, TabAccessNames, ARR_ACCESS_PART_KEY, mainPath };
